<template>
  <div
    v-if="showTenantModal"
    class="modal top-0 bottom-0 w-full h-full fixed flex justify-center items-center"
  >
    <div class="overlay fixed w-full h-full top-0"></div>
    <div class="modal-content w-full ">
      <!-- close button -->
      <div
        @click="close"
        class="close  flex flex-row float-right justify-center items-center m-2 text-white cursor-pointer"
      >
        <img :src="require('../../assets/close.png')" alt="" />
      </div>

      <div class="bg-white px-8 py-4  max-h-screen overflow-y-scroll">
        <div class="modal-title font-semibold mb-12">New Tenant</div>
        <div class="flex flex-row flex-wrap">
          <div class="flex flex-col flex-grow items-start mb-12 mr-12">
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold">First Name:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.first_name"
                  :errorMessage="errors.first_name"
                  :error="errors.first_name"
                  placeholder="First Name"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Last Name:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  v-model="form.last_name"
                  :errorMessage="errors.last_name"
                  :error="errors.last_name"
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Email:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="email"
                  v-model="form.email"
                  :errorMessage="errors.email"
                  :error="errors.email"
                  placeholder="Email"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Phone Number:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="phone"
                  :error="errors.phone_number"
                  :errorMessage="errors.phone_number"
                  v-model="form.phone_number"
                  placeholder="Phone Number"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Password:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="password"
                  name="phone"
                  :error="errors.password"
                  :errorMessage="errors.password"
                  v-model="form.password"
                  placeholder="Password"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Confirm Password:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="password"
                  name="phone"
                  :error="errors.password"
                  :errorMessage="errors.password"
                  v-model="form.password_confirmation"
                  placeholder="Confirm Password"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col flex-grow items-start mb-12">
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold">Assign Admin:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  :error="errors.admin"
                  v-model="form.admin"
                  :errorMessage="errors.admin"
                  :items="tenantAdmin"
                  placeholder="Assign Admin"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Country:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.country"
                  :error="errors.country"
                  type="text"
                  placeholder="Country"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">State:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.state"
                  :error="errors.country"
                  type="text"
                  placeholder="State"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Company Name:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.company_name"
                  :error="errors.company_name"
                  type="text"
                  placeholder="Company Name"
                />
              </div>
            </div>
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Company Prefix:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.tenant_prefix"
                  :error="errors.tenant_prefix"
                  :errorMessage="errors.tenant_prefix"
                  type="text"
                  placeholder="Company Prefix"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-center items-center">
          <div class="mb-8">
            <lms-button @click="handleFormSubmit">Add Tenant</lms-button>
          </div>
          <div class="mx-auto text-center mb-6 import">
            <span class="mr-2"><i class="fas fa-upload fa-2x"></i></span>Import
            bulk from csv instead
            <input ref="file" @change="selectFile" type="file" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import Api from "@/utils/api";
export default {
  model: {
    prop: "showTenantModal",
    event: "closeAdminModal",
  },
  props: {
    showTenantModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      tenantAdmin: [],
      roles: this.$store.state.admin.adminRoles,
      gender: [
        {
          text: "Male",
          value: "male",
        },
        {
          text: "Female",
          value: "female",
        },
      ],
      errors: [],
      form: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        gender: "",
        admin: "",
        state: "",
        company_name: "",
        tenant_prefix: "",
        file: null,
      },
    };
  },
  methods: {
    ...mapActions(["createTenant", "fetchTenants"]),
    ...mapMutations(["updateLoader"]),
    selectFile() {
      this.file = this.$refs.file.files;
    },
    async bulkAdd() {
      this.errors = [];

      //console.log({ gg: this.file });
      let payload = new FormData();
      payload.append("file", this.file[0]);
      this.updateLoader(true);
      let res = await Api.post(`tenant/bulk/insert`, payload, true);
      this.updateLoader(false);
      if (res.status == 200 || res.status == 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Tenants created successfully",
        });
        window.reload();
      } else {
        // this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].source
            : "An error occured",
        });
      }
    },
    async handleFormSubmit() {
      if (this.file) {
        return this.bulkAdd();
      }
      this.errors = [];
      let res = await this.createTenant(this.form);

      if (res.status == 201) {
        this.$emit("notify", {
          type: "success",
          message: "Tenant created successfully",
        });
        this.fetchTenants();
        this.close();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
          this.errors = res.data.errors[0].source;
        }
      }
    },
    close() {
      this.$emit("closeAdminModal", false);
    },
  },
  created() {
    this.$store.state.admin.admins.filter((a) => {
      if (a.role === "Tenant Assistant") {
        this.tenantAdmin.push({
          text: `${a.first_name} ${a.last_name}`,
          value: a.id,
        });
      }
    });
  },
  components: {
    linput: () => import("@/components/general/input"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-admin);
    }

    .modal-field {
      color: color(lms-admin);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
    }
    z-index: 1;
  }
}
</style>
